import styled from "styled-components";
import { ListContentLoader } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

const LoadingSuggestionsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 465px;
`;

export const LoadingSuggestions = () => {
    return (
        <LoadingSuggestionsContainer>
            <ListContentLoader
                loaderTitle={translate("website.research.market.builder.suggestions.loading.title")}
                loaderSubtitle={translate("website.research.market.builder.suggestions.loading.subtitle")}
            />
        </LoadingSuggestionsContainer>
    );
};
